import { Component, OnInit, ElementRef, TemplateRef,ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SportService } from '../services/sport.service';
import * as moment from 'moment';
import { resolve } from 'q';
import { ToastrService } from 'ngx-toastr';
import { SocketServiceService } from '../services/socket-service.service';
import { LoginService } from '../services/login.service'
import { CookieService } from 'ngx-cookie-service';
import { ReportService } from '../services/report.service';

@Component({
  selector: 'app-no-active-page',
  templateUrl: './no-active-page.component.html',
  styleUrls: ['./no-active-page.component.scss'],
  providers: [HeaderComponent, SidebarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoActivePageComponent implements OnInit {
  allSportsList: any;
  mobileAllSportsList: any;
  exchangeGameList: any;
  iUrl: any;

  constructor(private loginService: LoginService,private modalService: BsModalService,private reportService: ReportService, private cdRef: ChangeDetectorRef, private cookie: CookieService, private socketService: SocketServiceService, private route: ActivatedRoute,
    private head: HeaderComponent, private router: Router, private sport: SportService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.exchangeGame();
    this.getAllSportsListData();
    this.getAllSportsList();
  }
  getAllSportsListData() {
    let userData = {dashboard : true};
    this.sport.getAllSportsList(userData).subscribe(res => {
      this.allSportsList = res.data
      this.allSportsList = (this.allSportsList).sort(function (a, b) { return b.sport_id - a.sport_id });
    })
  }
  getAllSportsList() {
    let userData = {};
    this.sport.getAllSportsList(userData).subscribe(res => {
      this.mobileAllSportsList = res.data
      this.mobileAllSportsList = (this.mobileAllSportsList).sort(function (a, b) { return b.sport_id - a.sport_id });
    })
  }
  
  goToDashboard(sportName, id, data) {
    if (id == -100) {
      this.router.navigate(['casino']);
    } else  if (id < -100) {
      this.router.navigate(['snova/' + id + '/' + data.name + '/' + data.providerCode])
    } else if(id > -100){
      this.router.navigate(['dashboard/' + sportName]);
    }
  }
  exchangeGame() {
    let data = {
      sport_id: "-100"
    };
    this.sport.getHomeMatchesList(data).subscribe((res) => {
      if (res.status == true) {
        this.exchangeGameList = res.data
      }
    })
  }
  gotoexchangeGame(cardData) {
    let data = {
      game_id : cardData.match_id
    }
    this.sport.lotusLaunch(data).subscribe((res) => {
      if(res.status == true){
        // window.open(res.launchUrl, '_blank')
        this.iUrl = res.launchUrl;
        localStorage.setItem('casino',this.iUrl)
        this.router.navigate(['casino-detail'])
      }
    })
  }
  goToAll(sportName) {
    this.router.navigate(['dashboard/' + sportName]);
  }
  
  inplay() {
    this.router.navigate(['inplay'])
  }
}
